import Reflux from 'reflux';

const RemoteTeleprompterActions = Reflux.createActions({
  emitOperatorSettings: {},
  emitScrollPosition: {},
  emitCache: {},
  toggleSetting: {},
  updateOperatorScrollTop: {},
});

export default RemoteTeleprompterActions;
